export default __webpack_public_path__ + "static/media/c5b7ebbba024e5fcdea9be56cc727fef1581623768508.9047b5d9.webp";